var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.286c0-.474-.305-.908-.792-1.133a1.71 1.71 0 00-1.542.064L.666 2.79c-.69.394-.872 1.19-.413 1.784.46.594 1.392.751 2.081.357L4.5 3.69v11.74h-3c-.83 0-1.5.574-1.5 1.285C0 17.426.67 18 1.5 18h9c.83 0 1.5-.575 1.5-1.286 0-.71-.67-1.285-1.5-1.285h-3V1.286z",
    fill: "#00B9EF"
  })));
}

export default SvgOne;